import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';
import { OfferListingItemComponent } from '@features/offer-ui/components/offer-listing-item/offer-listing-item.component';
import { OfferHelper } from '@features/offer/helpers';
import { LetModule, PushModule } from '@ngrx/component';
import { TranslateModule } from '@ngx-translate/core';
import { MainContainerComponent } from '@rd/core/containers/main-container/main-container.component';
import { SharedModule } from '@rd/shared-legacy/shared.module';
import { BannerImageSrcDirective } from '@rd/shared-legacy/widgets/banner-image/banner-image-src.directive';
import { BannerImageModule } from '@rd/shared-legacy/widgets/banner-image/banner-image.module';
import { WestpacAppComponent } from './app.component';
import { WestpacAuthSecureRouteDialogComponent } from './components/auth-secure-route-dialog/auth-secure-route-dialog.component';
import { WestpacBypassBlockComponent } from './components/bypass-block/bypass-block.component';
import { WestpacFooterComponent } from './components/footer/footer.component';
import { WestpacHeaderComponent } from './components/header/header.component';
import { WestpacHomePageComponent } from './components/home-page/home-page.component';
import { WestpacMobileHeaderComponent } from './components/mobile-header/mobile-header.component';
import { WestpacOfferListingBannerComponent } from './components/offer/listing-offer/listing-banner.component';
import { WestpacAnalyticsService } from './services/analytics/analytics.service';
import { WestpacGiftCardSettingService } from './services/gift-card-setting/gift-card-setting.service';
import { WestpacOfferSettingService } from './services/offer-setting.service';
import { WestpacPaymentGatewayService } from './services/payment-gateway/payment-gateway.service';

const declaredComponents: any[] = [
  WestpacAppComponent,
  WestpacAuthSecureRouteDialogComponent,
  WestpacBypassBlockComponent,
  WestpacFooterComponent,
  WestpacHeaderComponent,
  WestpacHomePageComponent,
  WestpacMobileHeaderComponent,
  WestpacOfferListingBannerComponent,
];

@NgModule({
  declarations: [...declaredComponents],
  imports: [
    BannerImageModule,
    BannerImageSrcDirective,
    CommonModule,
    MainContainerComponent,
    MatSidenavModule,
    OfferListingItemComponent,
    LetModule,
    PushModule,
    RouterModule,
    SharedModule,
    RouterModule,
    TranslateModule.forChild(),
  ],
  exports: [...declaredComponents],
  providers: [
    OfferHelper,
    WestpacGiftCardSettingService,
    WestpacOfferSettingService,
    WestpacAnalyticsService,
    WestpacPaymentGatewayService,
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        hideRequiredMarker: true,
      },
    },
  ],
})
export class WestpacModule {}
